import { AnalyticsCartLineItems, AnalyticsCartType } from "lib/types/analytics";

export const getCartForAnalytics = (lineItems: any, billing: any) => {
  const items: AnalyticsCartLineItems[] = [];
  lineItems?.forEach((item: any) =>
    items.push({
      item_id: item.variant_id,
      price: parseFloat(item.price) * 100,
      product_id: item.product_id,
      quantity: item.quantity,
      title: item.item_title,
      variant_id: item.variant_id,
      product_url: item.item_url ?? null,
      product_image: item.image ?? null,
    }),
  );
  const cart: AnalyticsCartType = {
    currency: "INR",
    line_items: items,
    total_price: billing?.total_payable ? parseInt(billing?.total_payable) * 100 : 0,
  };
  return cart;
};
